import { Star } from "@mui/icons-material";
import { useState } from "react";
import theme from "theme";
import { ManagementCard } from "routes/lenses/lens/admin/management/ManagementCard";
import { SectionValueImportDialog } from "../../profileimport/SectionValueImportDialog";
import { useAppSelector } from "redux/hooks";
import { selectOutcomeEnabledFormSections } from "redux/slices/form.slice";

export function ImportSectionValues() {
  const [showImportDialog, setShowImportDialog] = useState<boolean>(false);
  const outcomeEnabledFormSections = useAppSelector(selectOutcomeEnabledFormSections);

  return outcomeEnabledFormSections.length > 0 ? (
    <>
      <ManagementCard
        id="lens-admin-management-import-sections"
        title="Import Sections"
        onClick={() => setShowImportDialog(true)}
        Icon={Star}
        color={theme.palette.grey[100]}
      />
      {showImportDialog && <SectionValueImportDialog onClose={() => setShowImportDialog(false)} />}
    </>
  ) : (
    <></>
  );
}
